/**
 * ReOrder class for my orders
 */
import ReOrderRepository from '../../repositories/ReOrderRepository';
export default class ReOrder {
    constructor() {
        if (document.getElementsByClassName('lm2-js-my-orders').length < 1) return;

        this.orderHistoryObserver();
        this.repository = new ReOrderRepository();
    }

    /**
     * Mutation observer/Event listerners
     * Waiting for Order list to Load before
     * Adding event listerners to reorder buttons
     */
    orderHistoryObserver() {
        const observer = new MutationObserver((mutationList, observer) => {
            mutationList.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    for (let item of document.querySelectorAll('.re-order-item')) {
                        item.addEventListener('click', (event) => {
                            let payLoad = {};

                            if (event.target.classList.contains('order-item-order')) {
                                payLoad = {
                                    orderNumber: event.target.getAttribute('data-orderNr'),
                                    contentLinkId: event.target.getAttribute('data-contentlinkid')
                                };
                            }

                            this.repository.getReorderDataAsJsonAsync(payLoad);
                        });
                    }
                }
            });
        });

        observer.observe(
            document.querySelector('#observeMyOrders'),
            {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true,
            },
            this.repository
        );
    }
}
